// For environment details see: https://confluence.mtvi.com/display/TCP/Global+Entry+-+execution+environment+-+Level+1+-+development

export * from './environment.common';
export const production = false;
